var RgPipes = /* @__PURE__ */ ((RgPipes2) => {
  RgPipes2[RgPipes2["Filter"] = 0] = "Filter";
  RgPipes2[RgPipes2["ClearZone"] = 1] = "ClearZone";
  RgPipes2[RgPipes2["AddPlots"] = 2] = "AddPlots";
  RgPipes2[RgPipes2["SkeletonTailorAnatomy"] = 3] = "SkeletonTailorAnatomy";
  RgPipes2[RgPipes2["AddMuscles"] = 4] = "AddMuscles";
  RgPipes2[RgPipes2["CalcAnatomyCores"] = 5] = "CalcAnatomyCores";
  RgPipes2[RgPipes2["CalcAnatomyEntrances"] = 6] = "CalcAnatomyEntrances";
  RgPipes2[RgPipes2["AggNmcs"] = 7] = "AggNmcs";
  RgPipes2[RgPipes2["AddCornerCores"] = 8] = "AddCornerCores";
  RgPipes2[RgPipes2["AddCorridors"] = 9] = "AddCorridors";
  RgPipes2[RgPipes2["SetLevelData"] = 10] = "SetLevelData";
  RgPipes2[RgPipes2["AddPodium"] = 11] = "AddPodium";
  RgPipes2[RgPipes2["AddTechSpaces"] = 12] = "AddTechSpaces";
  RgPipes2[RgPipes2["RemoveEmptyBuildings"] = 13] = "RemoveEmptyBuildings";
  RgPipes2[RgPipes2["Resize"] = 14] = "Resize";
  RgPipes2[RgPipes2["MatchFloors"] = 15] = "MatchFloors";
  RgPipes2[RgPipes2["AddPodiumEmptySpaces"] = 16] = "AddPodiumEmptySpaces";
  RgPipes2[RgPipes2["AddOpenings"] = 17] = "AddOpenings";
  RgPipes2[RgPipes2["AddRoofAndParapet"] = 18] = "AddRoofAndParapet";
  RgPipes2[RgPipes2["AddFacade"] = 19] = "AddFacade";
  RgPipes2[RgPipes2["AddPodiumGlazing"] = 20] = "AddPodiumGlazing";
  RgPipes2[RgPipes2["GeneratePolygons"] = 21] = "GeneratePolygons";
  RgPipes2[RgPipes2["SetBuildingIndexes"] = 22] = "SetBuildingIndexes";
  return RgPipes2;
})(RgPipes || {});
export {
  RgPipes
};
//# sourceMappingURL=index5.js.map
